import * as XLSX from 'xlsx'

export function downloadCustomerTemplate() {
  const worksheet = XLSX.utils.aoa_to_sheet([
    [
      'Company Name',
      'Contact Person Name',
      'Contact Person Phone Number',
      'Contact Person Email ID',
      'Address Line 1',
      'Address Line 2',
      'City',
      'State',
      'Pincode',
      'Country',
      'GST',
    ],
    [
      'Acme Technologies',
      'John Doe',
      '9876543210',
      'john.doe@example.com',
      '123 Business Hub',
      'MG Road',
      'Bangalore',
      'Karnataka',
      '560001',
      'India',
      '29ABCDE1234F1Z5',
    ],
  ])

  worksheet['!cols'] = [
    { wch: 25 },
    { wch: 22 },
    { wch: 25 },
    { wch: 28 },
    { wch: 30 },
    { wch: 25 },
    { wch: 18 },
    { wch: 18 },
    { wch: 14 },
    { wch: 16 },
    { wch: 20 },
  ]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Customer Template')
  XLSX.writeFile(workbook, 'Customer_Template.xlsx')
}
